
import { Vue, Component } from 'vue-property-decorator';
import config from '@/config';
import SvgHomeServiceProvidersPicto from '@/components/Home/SvgHomeServiceProvidersPicto.vue';

@Component({
  components: {
    SvgHomeServiceProvidersPicto,
  },
})
export default class ServiceProviders extends Vue {
  providersLogo: String[] = [require('@/assets/providers/boogi.png'), require('@/assets/providers/gotoo.png')];

  get MerchantUrl(): string | null {
    if (config.merchantUrl) {
      return config.merchantUrl;
    }
    return '#';
  }

  get contactEmail() {
    return config.contactEmail || 'contact@transway.fr';
  }
}
